import { QuestionnaireForm } from "@/components/questionnaire/QuestionnaireForm.tsx";
import { QuestionnaireProvider } from "@/components/questionnaire/QuestionnaireProvider.tsx";
import { ApplicantMergeProfileCompare } from "@/pages/recruit/candidates/components/ApplicantMergeProfileCompare.tsx";
import { FeedbackScoreCardProps } from "@/pages/recruit/scorecards/feedback/scorecards-feedback.ts";
import analyticsService, {
  analyticEvents,
  analyticProperties,
} from "@/services/analytics-service.ts";
import { ApiFormType } from "@/types/forms/form.types.ts";
import {
  Avatar,
  FullScreenPage,
  Title,
  Button,
  ButtonIcon,
  FontAwesomeIcon,
  Stack,
} from "@skailer-com/uikit";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export function FeedbackScoreCardFill({ feedback, setForcedState }: FeedbackScoreCardProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [applicantIsCollapsed, setApplicantIsCollapsed] = useState<boolean>(true);

  return (
    <FullScreenPage
      title={`${t("scorecards:scorecard")}: ${feedback?.scorecard.title ?? ""}`}
      backSlot={
        <Button
          variant={"secondary"}
          size={"lg"}
          onClick={() => {
            navigate(-1);
          }}
        >
          {t("common:exit")}
        </Button>
      }
      rightSideSlot={
        feedback.applicant &&
        !applicantIsCollapsed && (
          <Stack
            className={
              "fixed right-0 top-0 z-40 h-screen w-100 bg-light px-6 pt-20 pb-6 overflow-auto shadow-left"
            }
          >
            <ButtonIcon
              variant={"secondary"}
              className={"absolute top-6 right-6"}
              icon={<FontAwesomeIcon icon="fa-light fa-xmark-large" />}
              onClick={() => {
                setApplicantIsCollapsed(true);
              }}
            />
            {feedback.applicant && (
              <ApplicantMergeProfileCompare
                applicant={feedback.applicant}
                fixedHeaderHeight={false}
              />
            )}
          </Stack>
        )
      }
      isCenterVertical={false}
    >
      <QuestionnaireProvider
        type={ApiFormType.scoreCard}
        id={feedback.id}
        onAfterSubmit={() => {
          if (setForcedState) setForcedState(undefined);

          analyticsService.trackEvent(analyticEvents.scoreCards.feedbackCompleted, {
            [analyticProperties.id]: feedback.id,
          });
        }}
      >
        <QuestionnaireForm />
      </QuestionnaireProvider>
      {applicantIsCollapsed && feedback.applicant && (
        <Stack
          className={"sm:fixed right-0 top-20 sm:pt-35 pr-6 pb-4 cursor-pointer"}
          onClick={() => {
            setApplicantIsCollapsed(false);
          }}
          gap={"smd"}
        >
          <Avatar
            url={feedback.applicant?.photo_url}
            size={"2xl"}
            acronym={
              feedback.applicant
                ? `${feedback.applicant.first_name} ${feedback.applicant.last_name}`
                : ""
            }
          />
          <Title
            header={t("scorecards:show_profile", {
              applicant: feedback.applicant
                ? `${feedback.applicant.first_name} ${feedback.applicant.last_name}`
                : "",
            })}
            className={"max-w-40"}
          />
        </Stack>
      )}
    </FullScreenPage>
  );
}
